export function headerSearch() {
    const searchToggleButton = document.getElementById('toggle-search')
    const searchInput = document.getElementById('header-search-input')
    const searchForm = document.querySelector('.header-search form')
    const searchSubmit = document.querySelector('.header-search form button')
    const searchContainer = document.querySelector('.header-search .sub-menu')
    const prevMenuItem = document.querySelector('.header-search').previousElementSibling;

    function toggleSearchTabIndex(setting) {
        searchInput.setAttribute('tabindex', setting);
        searchSubmit.setAttribute('tabindex', setting);
    }

    function toggleSearchView(event) {
        searchContainer.classList.toggle('hidden')
        searchToggleButton.setAttribute(
          'aria-pressed', 
          `${searchToggleButton.getAttribute('aria-pressed') !== 'true'}`
        );

        if (searchToggleButton.getAttribute('aria-pressed') == 'true') {
            toggleSearchTabIndex(0);
            searchContainer.setAttribute('aria-expanded', true)
            searchInput.focus();
        } else {
            searchContainer.setAttribute('aria-expanded', false)
            toggleSearchTabIndex(-1);
        }
    }

    function checkSubmitFocusOut(event) {
        if (!(event.relatedTarget == searchInput)) {
            searchToggleButton.setAttribute('aria-pressed', false);
            searchContainer.setAttribute('aria-expanded', false)
            toggleSearchTabIndex(-1)
            searchToggleButton.focus();
            searchContainer.classList.toggle('hidden')
        } 
    }

    function checkInputFocusOut(event) {
        if (event.relatedTarget == searchToggleButton) {
            searchToggleButton.setAttribute('aria-pressed', false);
            searchContainer.setAttribute('aria-expanded', false)
            toggleSearchTabIndex(-1);
            searchContainer.classList.toggle('hidden')
        } 
    }

    function closeSearch() {
        if (searchToggleButton.getAttribute('aria-pressed') == 'true') {
            searchToggleButton.setAttribute('aria-pressed', false);
            searchContainer.setAttribute('aria-expanded', false)
            toggleSearchTabIndex(-1)
            searchContainer.classList.toggle('hidden')
        }
    }

    searchToggleButton.addEventListener('click', (event) => {
      toggleSearchView(event)
    });

    searchSubmit.addEventListener('blur', (event) => {
        checkSubmitFocusOut(event)
    })

    prevMenuItem.addEventListener('focusin', closeSearch)
    prevMenuItem.addEventListener('mouseover', closeSearch)
}